"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmptyReference = void 0;
const getEmptyReference = () => ({
    bosApiId: null,
    id: null,
    ifsId: null,
    pimCode: null,
    pimId: null,
    santanderId: null,
});
exports.getEmptyReference = getEmptyReference;
//# sourceMappingURL=reference.js.map